import { CHANGE_CARD_LABEL } from '../../utils/changeCardEntry';
import { IMPORT_LABEL, importPath } from '../../utils/importEntry';
import { canAddItemsNow, canWriteCard } from '../../utils/permissions';
import { HISTORY, UPLOAD } from '../icons';

/** Import a spreadsheet onto this card (KPR-1899): null for anyone who cannot add to it here. */
export function cardImportPath(collection, collectionId, cardId) {
	return collectionId && cardId && canAddItemsNow(collection) && canWriteCard(collection, cardId) ? importPath(collectionId, cardId) : null;
}

/**
 * The card editor's ⋯ entries that only a saved card has, in taxonomy order
 * (record · share · destructive). Moved out of CardDefinitionForm (KPR-710),
 * which is held to its file-size baseline.
 *
 * - History… needs the right to edit the card.
 * - Change card… (KPE-028, KPR-710) moves every item of the card to another
 *   card. It is a manager's act, so `changeCardPath` is null — and the entry
 *   absent — for anyone else, and for a card opened with no collection (the
 *   page works within one). The API refuses a non-manager regardless.
 * - Import a spreadsheet… (KPR-1899) goes to the import page with this card
 *   chosen, for anyone who can add items to it there.
 * - Delete card… is the door to the Danger zone tab, as a collection's ⋯ is.
 */
export function savedCardHeaderActions({
	isNewRecord, readOnly, editingLocked, currentCardId, changeCardPath, importSheetPath = null,
	onHistory, onChangeCard, onImport, onExport, onDelete,
}) {
	if (isNewRecord || !currentCardId) return [];
	return [
		!readOnly ? { key: 'history', group: 'record', icon: <HISTORY />, label: 'History…', onClick: onHistory } : null,
		changeCardPath ? {
			key: 'change-card',
			group: 'record',
			glyph: 'card',
			label: `${CHANGE_CARD_LABEL}…`,
			title: 'Move every item of this card to another card',
			onClick: onChangeCard,
		} : null,
		importSheetPath ? {
			key: 'import-spreadsheet',
			group: 'record',
			icon: <UPLOAD />,
			label: `${IMPORT_LABEL}…`,
			onClick: () => onImport(importSheetPath),
		} : null,
		{ key: 'export', group: 'share', glyph: 'export', label: 'Export…', onClick: onExport },
		!editingLocked ? { key: 'delete', group: 'destructive', glyph: 'delete', label: 'Delete card…', onClick: onDelete } : null,
	];
}
